import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { formatStringToNumber } from "utils/formatters";
import { CurrencyInputField, InputField, SelectField } from "components/form";
import { EquipmentFormValue } from "../../../types";
import { FieldsContainer } from "../../components/FieldsContainer";
import { equipmentConditions, equipmentYears } from "../../../constants";

export const CommonInfo = () => {
  const { control } = useFormContext<EquipmentFormValue>();

  return (
    <Stack gap="1rem">
      <Typography variant="h6" component="span">
        Details
      </Typography>

      <FieldsContainer columns={5}>
        <InputField
          label="Quanlity"
          control={control}
          name="commonInfo.quality"
          inputProps={{ type: "number" }}
          formatter={formatStringToNumber}
        />

        <SelectField label="Year" control={control} name="commonInfo.year" options={equipmentYears} />

        <InputField label="Make" name="commonInfo.make" control={control} />

        <InputField label="Model" name="commonInfo.model" control={control} />

        <InputField
          label="Class"
          control={control}
          name="commonInfo.class"
          inputProps={{ type: "number" }}
          formatter={formatStringToNumber}
        />

        <InputField label="Serial/VIN#" name="commonInfo.vin" control={control} />

        <InputField label="Stock ID" name="commonInfo.stockId" control={control} />

        <SelectField label="Condition" name="commonInfo.condition" control={control} options={equipmentConditions} />

        <InputField
          label="Mileage"
          control={control}
          name="commonInfo.mileage"
          inputProps={{ type: "number" }}
          formatter={formatStringToNumber}
        />

        <InputField label="Description" name="commonInfo.description" control={control} />

        <CurrencyInputField label="Wholesale Cost" name="commonInfo.saleCost" control={control} />

        <CurrencyInputField label="Total Wholesale Cost" name="commonInfo.wholeSaleCost" control={control} />

        <CurrencyInputField label="Total Retail Price" name="commonInfo.retailPrice" control={control} />
      </FieldsContainer>
    </Stack>
  );
};
